import { app } from '../../../bootstrap/core';
import infoCheckboxComponent from './infoCheckbox.component';

app.component('infoCheckbox', infoCheckboxComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/infoCheckbox/infoCheckbox.js